import { render } from "./invoice_and_delivery_note.vue?vue&type=template&id=534364f0&scoped=true"
import script from "./invoice_and_delivery_note.vue?vue&type=script&lang=js"
export * from "./invoice_and_delivery_note.vue?vue&type=script&lang=js"

import "./invoice_and_delivery_note.vue?vue&type=style&index=0&id=534364f0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-534364f0"]])

export default __exports__